import template from './phoneNumber.html';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    phoneClass: '@',
    phoneTabIndex: '@?',
    Id: '@?',
    phoneMaskId: '@?',
    phoneMask: '=',
    model: '=',
    showPhoneMask: '<',
  },
};
